// extracted by mini-css-extract-plugin
module.exports = {"formPanel":"SalesForm_formPanel__35cg7","formRow":"SalesForm_formRow__elgyJ"};